/**
 * Format a number in compact notation (e.g., 1.2k, 15k, 1.5M)
 */
export function formatCompactNumber(num: number): string {
  if (num < 1000) {
    return num.toString();
  }
  if (num < 10000) {
    const formatted = (num / 1000).toFixed(1);
    return formatted.endsWith('.0') ? `${Math.floor(num / 1000)}k` : `${formatted}k`;
  }
  if (num < 1000000) {
    return `${Math.floor(num / 1000)}k`;
  }
  const formatted = (num / 1000000).toFixed(1);
  return formatted.endsWith('.0') ? `${Math.floor(num / 1000000)}M` : `${formatted}M`;
}

/**
 * Format a date as relative time (e.g., "5m ago", "2h ago", "3 days ago")
 * or as a formatted date for older dates
 */
export function formatRelativeDate(date: Date | string): { relative: string; time: string } {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const now = new Date();
  const diffMs = now.getTime() - dateObj.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  let relative: string;
  if (diffMinutes < 1) {
    relative = 'now';
  } else if (diffMinutes < 60) {
    relative = `${diffMinutes}m ago`;
  } else if (diffHours < 24) {
    relative = `${diffHours}h ago`;
  } else if (diffDays < 7) {
    relative = diffDays === 1 ? '1 day ago' : `${diffDays} days ago`;
  } else {
    relative = dateObj.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: dateObj.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
    });
  }

  const time = dateObj.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });

  return { relative, time };
}
